import React, { Component } from "react";
import { BaypageM } from "../../Model/Content"; //Include Home
import { Banner } from "../banner/Banner"; //Include Banner
import { Special } from "../special/Special"; //Include Special
import Search from "../search/Search";
import { userprofile } from "../../Model/Users";
import Notification from "../Notification/Notification";
import { Link } from "react-router-dom";
import { Docubytes } from "../Docubytes/Docubytes";
import { StartExploring } from "../startExploring/startExploring";
import { Layout1 } from "../Layout1/Layout1";
import { Layout2 } from "../Layout2/Layout2";
import { Layout3 } from "../Layout3/Layout3";
import { Layout9 } from "../Layout9/Layout9";
import { Layout5 } from "../Layout5/Layout5";
import { Layout7 } from "../Layout7/Layout7";
import { Layout8 } from "../Layout8/Layout8";
import { Layout10 } from "../Layout10/Layout10";
import { Layout11 } from "../Layout11/Layout11";
import { Layout12 } from "../Layout12/Layout12";
import { Layout13 } from "../Layout13/Layout13";
import { Layout14 } from "../Layout14/Layout14";
import { Layout15 } from "../Layout15/Layout15";
import { Layout16 } from "../Layout16/Layout16";
import { Layout17 } from "../Layout17/Layout17";
import { Layout18 } from "../Layout18/Layout18";
import Allbays from "../Allbays/Allbays";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { Metadata } from "../Metadata/Metadata";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { Footerdesk } from "../../components/FooterDesk/Footerdesk";
import Notifcationdesk from "../../components/Notifcationdesk/Notifcationdesk";
import { isMobile } from "react-device-detect";
import Header from "../common/Header";
import { Childlock } from "../Childlock/Childlock";
import BarLoader from "react-spinners/BarLoader";
import {
  SVGIcons,
  ImgIcons,
  VirsionCheck,
  withRouter,
  Appsflyer,
  branchIO,
} from "../../Helpers/Common";
var ImageData = "";
var SVGIcon = "";

ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));

class Baypage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      DataisLoaded: false,
      VirsionCheckData: "",
      VirsionCheckDataloaded: false,
      SearchClick: false,
      NotificationClick: false,
      Allbaysv: false,
      ContentSlug: false,
      userData: false,
      isLive: true,
      goldenDIcon: "",
      silverDIcon: "",
      goldenDOriginalIcon: "",
    };
  }

  componentDidMount() {
    var ContentSlug = window.location.pathname;
    ContentSlug = ContentSlug.split("/");
    ContentSlug = ContentSlug[2];
    this.setState({ ContentSlug: ContentSlug });
    BaypageM(ContentSlug).then((res) => {
      // Appsflyer("Bay Page Visited", { "Bay Name": ContentSlug })
      // branchIO("Bay Page Visited", { "Bay Name": ContentSlug });
      if (res.data.message && res.data.message == "session_expired") {
        this.props.navigate("/createaccount");
      } else {
        VirsionCheck().then((vcheckres) => {
          this.setState({
            isLive: JSON.parse(vcheckres.data).data.is_live_tv,
            goldenDIcon: JSON.parse(vcheckres.data).data["golden-dweb"],
            silverDIcon: JSON.parse(vcheckres.data).data["silver-dweb"],
            goldenDOriginalIcon: JSON.parse(vcheckres.data).data["d_original"],
          });
          if (vcheckres.data) {
            this.setState({
              items: JSON.parse(res.data.message),
              DataisLoaded: true,
            });
            this.setState({
              VirsionCheckData: vcheckres,
              VirsionCheckDataloaded: true,
            });
          }
        });
      }
    });
    let data = {
      seesionID: localStorage.getItem("session_id"),
      userID: localStorage.getItem("userID")
    }
    userprofile(data).then((userDatares) => {
      if (JSON.parse(userDatares.data.message).success == false) {
        this.props.navigate("/createaccount");
      }
      if (userDatares.data.message == "session_expired") {
        this.props.navigate("/createaccount");
      } else {
        var userDatares = JSON.parse(userDatares.data.message);
        this.setState({
          userData: userDatares.user_data,
        });
      }
    });
  }

  search() {
    this.setState({
      SearchClick: true,
    });
  }

  //
  SearchClose() {
    this.setState({
      SearchClick: false,
    });
  }

  Notification() {
    this.setState({
      NotificationClick: true,
    });
  }

  ShowallbaysClose() {
    this.setState({
      Showallbays: false,
    });
  }

  Showallbays() {
    this.setState({
      Showallbays: true,
    });
  }
  //
  NotificationClose() {
    this.setState({
      NotificationClick: false,
    });
  }

  render() {
    const { items, DataisLoaded, VirsionCheckData, VirsionCheckDataloaded } = this.state;
    if (DataisLoaded === false || this.state.VirsionCheckDataloaded === false) {
      // return <div className="loader"></div>;
      return (
        <div className="loader">
          <BarLoader color="#ff000f" />
        </div>
      );
    }

    //Search Tab Open

    if (this.state.SearchClick === true) {
      return (
        <Search
          functions={this}
          closefrom="true"
          goldenIcon={this.state.goldenDIcon}
          silverIcon={this.state.silverDIcon}
        />
      );
    }

    // Notification Tab Open
    if (this.state.NotificationClick === true) {
      return <Notification functions={this} />;
    }

    // document.addEventListener("scroll", () => {
    //   const header = document.querySelector("header");
    //   if (window.scrollY > 10) {
    //     header.classList.add("head-hide");
    //   } else {
    //     header.classList.remove("head-hide");
    //   }
    // });
    var Allbay = <Allbays functions={this.ShowallbaysClose} key="dd" />;
    const BayspageData = items.pageData.lists;
    var Baysdata = this.state.items.bayData;

    return (
      <>
        <Metadata page="BAY" name={this.state.ContentSlug} />
        <motion.div
          className=""
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 1 }}
          key="1"
        >
          <div className="banner-overlay dD-block"></div>
          <Header
            userprofile={this.state.userData}
            bayData={Baysdata}
            page={"baypage"}
            classdata={this}
          />

          {BayspageData?.map((data, index) => {
            if (data.section_layout == "Layout 0") {
              if (this.state.Showallbays === true) {
                return <Allbays functions={this} baydata={Baysdata} />;
              }
              if (this.state.Allbaysv === true) {
                var Data = Allbay;
              } else {
                var Data = "";
              }
              return [
                <Banner
                  BannerDatas={data.contents}
                  key={data.section_layout}
                  goldenIcon={this.state.goldenDIcon}
                  silverIcon={this.state.silverDIcon}
                  goldenOriginalIcon={this.state.goldenDOriginalIcon}
                />,
                Data,
              ];
            } else if (data.section_layout == "Layout 1") {
              return (
                <div className="latestBay">
                  <Layout1
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 2") {
              return (
                //SpecialBay
                <div className="latestBay">
                  <Layout2
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 3") {
              return (
                //TrendingBay
                <div className="latestBay">
                  <Layout3
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 5") {
              return (
                <div className="latestBay">
                  <Layout5
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 7") {
              return (
                <div className="latestBay">
                  <Layout7
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 8") {
              return (
                //Most WatchedBay
                <div className="latestBay">
                  <Layout8
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 9") {
              //AwardWinning
              return (
                <div className="latestBay">
                  <Layout9
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 10") {
              return (
                //TechBay
                <div className="latestBay">
                  <Layout10
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 11") {
              return (
                <div className="latestBay">
                  <Layout11
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 12") {
              //Docubuster of the month
              return (
                <div className="latestBay">
                  <Layout12
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 13") {
              return (
                //AdventureBay
                <div className="latestBay">
                  <Layout13
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 14") {
              return (
                //SurpriseMe
                <div className="latestBay">
                  <Layout14
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 15") {
              return (
                //Live TV
                <div className="latestBay">
                  <Layout15
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 16") {

              return (
                //Bay page second
                <div className="latestBay">
                  <Layout16
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 17") {
              return (
                //Live TV
                <div className="latestBay">
                  <Layout17
                    Layout1={data.contents}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else if (data.section_layout == "Layout 18") {
              return (
                //Live TV
                <div className="latestBay">
                  <Layout18
                    Layout1={data}
                    key={index}
                    title={data}
                    goldenIcon={this.state.goldenDIcon}
                    silverIcon={this.state.silverDIcon}
                  />
                </div>
              );
            } else {
            }
          })}
          <div className="pb-m"></div>
          {this.state.userData != false ? (
            <Childlock data={this.state.userData} />
          ) : null}
          <Footerdesk />
          <Mobilemenu active="1" isLive={this.state.isLive} />
        </motion.div>
      </>
    );
  }
}
export default withRouter(Baypage);
